import {isEqual} from 'lodash';

import {Modal} from '@/constants/actionType';
import {ModalInlineMessageType, ModalMode, ModalVariant} from '@/constants/modalEnum';

export const showModal =
  (type, variant = ModalVariant.GENERIC, mode = ModalMode.DEFAULT, actionClose = null, inlineMessageParams = {}) =>
  (dispatch) =>
    dispatch({
      type: Modal.SHOW,
      modalState: {
        show: true,
        type,
        variant,
        mode,
        hideCloseButton: Boolean(actionClose),
        actionClose,
        inlineMessageParams,
      },
    });

export const hideModal = () => (dispatch, getState) => {
  const {modalState} = getState();

  if (modalState.show) {
    dispatch({type: Modal.HIDE});
  }
};

export const setModalVariant = (variant) => (dispatch, getState) => {
  const {modalState} = getState();

  if (modalState.variant !== variant) {
    dispatch({type: Modal.SET_VARIANT, variant});
  }
};

export const setModalMode = (mode) => (dispatch, getState) => {
  const {modalState} = getState();

  if (modalState.mode !== mode) {
    dispatch({type: Modal.SET_MODE, mode});
  }
};

export const setShowCloseIcon = (value) => (dispatch, getState) => {
  const {modalState} = getState();

  if (modalState.hideCloseButton !== value) {
    dispatch({type: Modal.SET_HIDE_CLOSE_BUTTON, value});
  }
};

export const setInlineMessage = (inlineMessage) => (dispatch, getState) => {
  const {modalState} = getState();

  if (!isEqual(modalState.inlineMessage, inlineMessage)) {
    dispatch({type: Modal.SET_INLINE_MESSAGE, inlineMessage});
  }
};

export const setCloseOnBlur = (value) => (dispatch, getState) => {
  const {modalState} = getState();

  if (modalState.disableBlur !== value) {
    dispatch({type: Modal.SET_DISABLE_BLUR, value});
  }
};

export const setSize = (size) => (dispatch, getState) => {
  const {modalState} = getState();

  if (modalState.size !== size) {
    dispatch({type: Modal.SET_SIZE, size});
  }
};

export const setIsMinimized = (isMinimized) => (dispatch, getState) => {
  const {modalState} = getState();

  if (modalState.isMinimized !== isMinimized) {
    dispatch({type: Modal.SET_IS_MINIMIZED, isMinimized});
  }
};

export const resetModalState = () => (dispatch) => dispatch({type: Modal.RESET_STATE});

export const showModalWithErrorInline =
  (message, {type, variant, mode}) =>
  (dispatch) => {
    const inlineMessageParams = {
      type: ModalInlineMessageType.ERROR,
      message,
    };

    dispatch(showModal(type, variant, mode, null, inlineMessageParams));
  };

export const showGenericModal =
  ({header, content, actions = [], actionClose = () => {}}) =>
  (dispatch) =>
    dispatch({type: Modal.SHOW_GENERIC, header, content, actions, actionClose});
